import React from 'react';
import { Page, Layout } from '@shopify/polaris';
import { useHistory } from 'react-router-dom';

import ProductSettings from '../componets/ProductSettings';

const Settings = () => {
    const history = useHistory();

    return (
        <Page
            breadcrumbs={[{content: 'Home', onAction: () => history.push('/')}]}
            title="Settings"
            separator
        >
            <Layout>
                <Layout.Section>

                    {/* Card for prouct selection */}

                    <ProductSettings />

                </Layout.Section>
            </Layout>

        </Page>
    )
}

export default Settings;